import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from "../../shared/alert/alert.service";
import {Alert} from "../../shared/alert/Alert";

@Component({
  selector: 'app-auth-validate',
  templateUrl: './auth-validate.component.html',
  styleUrls: ['./auth-validate.component.scss']
})
export class AuthValidateComponent implements OnInit {

  validating = true;
  constructor(private alertService: AlertService, private router: Router,
              private activatedRoute: ActivatedRoute, private authService: AuthService) {}

  ngOnInit() {

    // subscribe to router event
    this.activatedRoute.params.subscribe((params: Params) => {

      this.authService.login(params['code']).subscribe(result => {

        const returnURL = localStorage.getItem('returnUrl');
        localStorage.removeItem('returnUrl');

        this.validating = false;
        if (result === true) {
          // login successful
          if(returnURL) {
            this.router.navigateByUrl(returnURL);
          } else {
            this.router.navigate(['/']);
          }
        } else {
          this.router.navigate(['/not-authorized']);
        }
      }, err => {
        this.validating = false;
        if (err.status === 403) {
          this.router.navigate(['/not-authorized']);
        } else {
          this.showError('Authentication failed');
          this.router.navigate(['/login']);
        }
      });
    });
  }

  showError(message) {
    const alert = new Alert(message);
    alert.autoHide = false;
    this.alertService.danger(alert);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-validate/auth-validate.component.ts